import { getAllCarQuoteParamsSchema } from '@apis/CarQuoteApi';
import { useParseParams } from '@hooks/params';

import { CarQuoteResultPageParams } from './route';

export const useCarQuotesResultPageParams = () => useParseParams<CarQuoteResultPageParams>(getAllCarQuoteParamsSchema);
